import {Component, Input, OnInit} from '@angular/core';
import {EcommerceService} from "../../../../ecommerce.service";
import {IMedia} from "../../../../ecommerce-product.interface";
import {first} from "rxjs/operators";
import {FileUtils} from "../../../../../../../shared/utils/file-utils";
import {FormArray} from "@angular/forms";
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";
import {ProductAddHelperService} from "../../product-add-helper.service";
import {NotifierComponent} from "../../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../../shared/components/notifier/notification-type";

@Component({
    selector: 'db-media-library',
    templateUrl: './media-library.component.html',
    styleUrl: './media-library.component.scss',
    standalone: false
})
export class MediaLibraryComponent implements OnInit {
  images: IMedia[] = [];
  imagesForm: FormArray;
  mediaFiles = [];
  files = [...this.mediaFiles];
  forMain: boolean = false;
  @Input() websiteId!: number;
  imageUploadError;
  selectedImages: IMedia[] = [];
  loading = false;
  fileExtensions = ['.mp4', '.avi', '.mkv', '.mov', '.wmv', '.flv', '.webm', '.3gp', '.png', '.jpg', '.jpeg'];

  constructor(private ecommerceService: EcommerceService,
              private productAddHelper: ProductAddHelperService,
              private _activeModal: DbActiveModal) {

  }

  ngOnInit() {
    this._getMediaList();
  }

  private _getMediaList() {
    this.loading = true;
    this.ecommerceService.getMediaList(this.websiteId)
      .pipe(first(resp => !!resp))
      .subscribe(value => {
        if (value.data) {
          this.images = value.data;
          this.loading = false;
        }
      });
  }

  async fileChange(event: EventTarget | null) {
    const files = (event as HTMLInputElement).files;
    const fileList = [];
    const maxFileCount = 5;
    if (files.length > maxFileCount) {
      NotifierComponent.notify(new Notification(`You can only upload up to ${maxFileCount} files.`, NotificationType.DANGER));
      return;
    }
    if (files && files.item(0)) {
      for (let i = 0; i < files.length; i++) {
        if (files.item(i).size > 15000000) {
          return this.imageUploadError = '<strong>Error:</strong> You exceeded maximum size for file upload.';
        }
        if (!FileUtils.checkExtension(files.item(i).type, [...this.fileExtensions])) {
          return this.imageUploadError = '<strong>Invalid file format.</strong> You can upload only images.';
        }
        if (FileUtils.checkExtension(files.item(i).type, [...this.fileExtensions])) {
          const currentFile = files.item(i) as File;
          const fileObj = {
            file: currentFile,
            base64: await FileUtils.FileToBase64(currentFile),
            imageUrl: '',
            order: i
          };
          fileList.push(fileObj);
          // this.imagesForm.push(this._productAddHelper.createImageControl());
        }
      }
      this._addImagesInSlider(fileList);
    }

    return null;
  }

  removeItem(id: number) {
    this.loading = true;
    this.ecommerceService.removeMediaItem(this.websiteId, id)
      .pipe(first(resp => !!resp))
      .subscribe(value => {
        if (value.data) {
          this.images = this.images.filter(img => img.id !== id);
          this.loading = false;
        }
      });
  }

  private async _addImagesInSlider(fileList) {
    this.loading = true;
    const imagesResp = await this.productAddHelper.uploadImages({media_group: {images: fileList}}, this.websiteId);
    const images = imagesResp.map(img => img.image);
    this.images = [...images, ...this.images];
    this.loading = false;
  }

  selectImage(image: IMedia) {
    if (image.selected) {
      image.selected = false;
      this.selectedImages = this.selectedImages.filter(img => img.id !== image.id);
      return;
    }
    image.selected = true;
    this.selectedImages.push(image);
  }

  addImagesToProduct() {
    this._activeModal.close(this.selectedImages);
  }
}
